var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('layout-label',{attrs:{"text":"パスワード","icon":"lock-fill"}}),_c('b-form-group',[_c('b-form-input',{attrs:{"type":"password"},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }